module.exports = __webpack_public_path__ + "img/teacherCenter1.e6089ea7.png";